import { render, staticRenderFns } from "./InvestorDashboardView.vue?vue&type=template&id=3c5a1a5a&scoped=true"
import script from "./InvestorDashboardView.vue?vue&type=script&lang=js"
export * from "./InvestorDashboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5a1a5a",
  null
  
)

export default component.exports